import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import sha512 from 'crypto-js/sha512';
import { Observable } from 'rxjs';
import { tap, shareReplay, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Config } from '../Config';
import { StorageService } from '../helpers/storage.service';
import { XTokenResponse } from './x-token-response';

const BASE_URL = environment.ACCESS_CONTROL

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private signatureCache = new Map<string, Observable<XTokenResponse>>();

  constructor(
    private config: Config,
    private storageService: StorageService,
    private httpClient: HttpClient,
  ) { }

  computeSignature(httpMethod: string, decodedUrl: string): Observable<XTokenResponse> {

    const cacheKey = `${httpMethod}_${decodedUrl}`;
    const CACHE_TTL_MS = 60000; // 60 seconds cache duration

    if (!this.signatureCache.has(cacheKey)) {
      const request$ = this.httpClient.post<XTokenResponse>(`${BASE_URL}${this.config.computeSignature}`, {
        httpMethod: httpMethod,
        decodedUrl: decodedUrl
      }).pipe(
        tap((res) => {

          // Automatically invalidate this specific cache entry after TTL expires
          setTimeout(() => {
            // Check if the current cached request is still the exact same instance before deleting
            // (prevents deleting a fresh cache if it was recently cleared manually)
            if (this.signatureCache.get(cacheKey) === request$) {
              this.signatureCache.delete(cacheKey);
            }
          }, CACHE_TTL_MS);
        }),
        catchError((error) => {
          // Remove from cache so it can be retried on failure
          this.signatureCache.delete(cacheKey);
          console.error('[TokenService] computeSignature failed:', error);
          throw error;
        }),
        shareReplay(1) // Cache the successful response for duplicate simultaneous requests
      );
      this.signatureCache.set(cacheKey, request$);
    }

    return this.signatureCache.get(cacheKey)!;
  }

  clearSignatureCache(): void {
    this.signatureCache.clear();
  }

}
